<div class="container" mat-dialog-content>
  <div class="headline">Teilnehmer hinzufügen</div>
  <form #form="ngForm" (ngSubmit)="addParticipant(form)">
    <div class="content">
      <div class="form-field-wrapper">
        <mat-form-field appearance="fill">
          <mat-label>E-Mail-Adresse</mat-label>
          <input
            matInput
            type="email"
            id="email-input"
            [(ngModel)]="emailAddress"
            class="form-control"
            required
            email
            #mail="ngModel"
            name="email" />
          @if (mail.invalid && (mail.dirty || mail.touched) && mail.errors?.required) {
            <mat-error>
              Bitte eine E-Mail-Adresse eingeben.
            </mat-error>
          }
          @if (mail.invalid && (mail.dirty || mail.touched) && mail.errors?.email) {
            <mat-error>
              Bitte eine gültige E-Mail-Adresse eingeben.
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>
    <div mat-dialog-actions>
      <button type="button" mat-flat-button mat-dialog-close>Abbrechen</button>
      <button type="submit" [disabled]="form.invalid" mat-flat-button color="primary">Speichern</button>
    </div>
  </form>
</div>
